import React, { memo } from 'react';
import { useSelector } from 'react-redux';
import {
  selectors,
  actionCreators,
  sliceKeys,
  roomsFilterNames,
} from '../../model';
import { useFilterDispatchers } from '../../services/modelInteraction';
import {
  useAddressStagesQuery,
  addressStagesSelectors,
} from '../../api/addressStages';
import {
  useAddressStepsQuery,
  addressStepsSelectors,
} from '../../api/addressSteps';
import {
  useAddressTypesQuery,
  addressTypesSelectors,
} from '../../api/adressTypes';
import DropdownSelect from '../../../../components/dropdownSelect';
import FilterActions from '../../shared/ui/FilterActions';
import { useStateWithSyncExternalData } from '../../shared/hooks/stateWithSyncExternalData';
import FilterContainer from '../../shared/ui/FilterContainer';

const { selectFilter } = selectors[sliceKeys.rooms];
const { filterChanged } = actionCreators[sliceKeys.rooms];

const MemoizedSelectStages = memo(StagesSelect);
const MemoizedSelectSteps = memo(StepsSelect);
const MemoizedSelectTypes = memo(TypesSelect);

const RoomsListFilter = ({ onClose }) => {
  const storeFilter = useSelector(selectFilter);

  const { state: filter, setState: onChange } =
    useStateWithSyncExternalData(storeFilter);

  const { onApply, onReset } = useFilterDispatchers({
    createAction: filterChanged,
    value: filter,
    cb: onClose,
  });

  return (
    <FilterContainer>
      <MemoizedSelectStages
        value={filter?.[roomsFilterNames.stages]}
        onChange={onChange}
      />
      <MemoizedSelectSteps
        value={filter?.[roomsFilterNames.steps]}
        onChange={onChange}
      />
      <MemoizedSelectTypes
        value={filter?.[roomsFilterNames.types]}
        onChange={onChange}
      />
      <FilterActions
        onReset={storeFilter ? onReset : onClose}
        onApply={storeFilter !== filter ? onApply : onClose}
      />
    </FilterContainer>
  );
};

export default RoomsListFilter;

const emptyArr = Object.freeze([]);

function StagesSelect({ value, onChange }) {
  const { data, isFetching } = useAddressStagesQuery({
    options: { select: addressStagesSelectors.toSelectOption },
  });

  return (
    <DropdownSelect
      options={!data || data === 'Error' ? emptyArr : data}
      loading={isFetching}
      multiple={true}
      value={value}
      onChange={(value) => onChange({ name: roomsFilterNames.stages, value })}
      label="Стадии"
    />
  );
}

function StepsSelect({ value, onChange }) {
  const { data, isFetching } = useAddressStepsQuery({
    options: { select: addressStepsSelectors.toSelectOption },
  });

  return (
    <DropdownSelect
      options={!data || data === 'Error' ? emptyArr : data}
      loading={isFetching}
      multiple={true}
      value={value}
      onChange={(value) => onChange({ name: roomsFilterNames.steps, value })}
      label="Этапы"
    />
  );
}

function TypesSelect({ value, onChange }) {
  const { data, isFetching } = useAddressTypesQuery({
    options: { select: addressTypesSelectors.toSelectOption },
  });

  return (
    <DropdownSelect
      options={!data || data === 'Error' ? emptyArr : data}
      loading={isFetching}
      multiple={true}
      value={value}
      onChange={(value) => onChange({ name: roomsFilterNames.types, value })}
      label="Типы"
    />
  );
}
